module.exports = __webpack_public_path__ + "img/V-63-ST-1200-BE.2d52dbda.png";